module.exports = __webpack_public_path__ + "static/media/Amtrust.cdf51346.webp";